import MainNavigationDropdownMenuItem from "components/MainNavigation/components/atoms/DropdownMenu/Item";
import { MainNavigationMenuItem } from "components/MainNavigation/types";
import Badge from "ds/components/Badge";

type MainNavigationProductUpdatesMenuItemProps = {
  item: MainNavigationMenuItem;
  onCloseDropdown: () => void;
  withNewBadge: boolean;
};

const MainNavigationProductUpdatesMenuItem = ({
  item,
  onCloseDropdown,
  withNewBadge,
}: MainNavigationProductUpdatesMenuItemProps) => {
  return (
    <MainNavigationDropdownMenuItem key={item.id} item={item} onCloseDropdown={onCloseDropdown}>
      {item.title}
      {withNewBadge && (
        <Badge color="info" size="small" state="info">
          New!
        </Badge>
      )}
    </MainNavigationDropdownMenuItem>
  );
};

export default MainNavigationProductUpdatesMenuItem;
